module.exports = __webpack_public_path__ + "img/20_91.97735b0b.png";